import React, { Fragment } from "react";
import styles from "./LoginButtons.css";

const LoginButtons = ({ onClick = () => {} }) => {
  const handleClick = href => e => {
    e.preventDefault();

    onClick(href);
  };

  return (
    <Fragment>
      <button
        onClick={handleClick("/api/facebook/login")}
        className={`${styles.button} ${styles.facebook}`}
      >
        Facebook
      </button>
      <button
        onClick={handleClick("/api/google/login")}
        className={`${styles.button} ${styles.google}`}
      >
        Google
      </button>
      <button
        onClick={handleClick("/api/twitter/login")}
        className={`${styles.button} ${styles.twitter}`}
      >
        Twitter
      </button>
    </Fragment>
  );
};

export default LoginButtons;



// WEBPACK FOOTER //
// ./src/components/Login/LoginButtons.js